import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom'; // Assuming you're using React Router
import './legalPage.scss'; // Import CSS file for styling if needed
import { LanguageContext } from '../../services/LanguageContext'; // Import your LanguageContext
import { translateText } from '../../services/deeplTranslationService'; // Import the translation service

const LegalPage = () => {
    const { pageType } = useParams(); // Get the URL parameter (e.g., agb, impressum, datenschutz)
    const { language } = useContext(LanguageContext); // Get the current language from context
    const [legalPage, setLegalPage] = useState(null);
    const [translatedContent, setTranslatedContent] = useState(null); // State to store translated content
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAndTranslateLegalPage = async () => {
            try {
                const response = await fetch('https://find-together-api.sslbeta.de/api/Support/getLegalPages');
                const data = await response.json();
                
                // Find the page data based on the URL parameter
                const pageData = data.find(page => page.type.toLowerCase() === pageType.toLowerCase());

                if (!pageData) {
                    setLegalPage(null);
                    setLoading(false);
                    return;
                }

                setLegalPage(pageData); // Set original content

                // If the language is not German, translate the content
                if (language !== 'DE') {
                    const translated = await translateText(pageData.content, language);
                    setTranslatedContent(translated); // Store the translated content
                } else {
                    setTranslatedContent(pageData.content); // Use the original content for German
                }
            } catch (error) {
                console.error('Error fetching legal page:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAndTranslateLegalPage();
    }, [pageType, language]);

    if (loading) {
        return <p>Laden...</p>;
    }

    if (!legalPage) {
        return <p>Seite nicht gefunden.</p>;
    }

    return (
        <div className="container inner-page-container">
            {/* Display the content as HTML */}
            <div className="legal-page-content" dangerouslySetInnerHTML={{ __html: translatedContent }} />
        </div>
    );
};

export default LegalPage;
